
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ShToastComponent } from '../../components/toast/toast.component';
import { Toast } from '../../entities/toast.entity';

@Component({
    selector: 'sh-toast-container',
    templateUrl: './toast-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShToastComponent]
})
export class ShToastContainerComponent {
    @Input() toasts!: Toast[];

    @Output() closeToast: EventEmitter<number> = new EventEmitter<number>();

    trackToastById(index: number, toast: Toast): number {
        return toast.id;
    }

    closeToastById(id: number): void {
        this.closeToast.emit(id);
    }
}
